angular.module('ui-ng-drag-drop').directive('dragDropZone', function dragDropZone() {
  return {
    restrict: 'EA',
    link: function (scope, element) {
      element.addClass('drag-drop-zone');
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-drag-drop/src/components/drag_drop_zone.js